<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交
          </van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <div style="padding-left: 16px">
        <van-field v-model="inputForm.code" label="口岸换装单编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorName" label="关务事务专员" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createByName" label="制单人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.transferTypeLabel" label="换装类型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </div>
      <van-collapse-item title="基础信息" name="1">
        <van-field v-model="inputForm.transferDate" label="换装日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field :value="inputForm.transferType === '1' ? inputForm.salesDepartNo : inputForm.customsApplyCode" :label="inputForm.transferType === '1' ? '销售发车单编号' : '报关单编号'" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.consignorName" label="境内发货人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.overseasReceiveCompany" label="境外收货公司" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.consigneeName" label="境外收货联系人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.consigneePhone" label="境外收货联系人联系方式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.finalDestinationCountryName" label="运抵国（地区）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.finalCityName" label="目的地城市" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departurePortName" label="离境口岸" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departurePlace" label="发车地点" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.totalWeightIncludePack" :formatter="formatter" label="发车含筐总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckNum" label="发车总件数（筐）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.totalWeightExcludePack" label="发车不含筐总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.averageWeightPerBasket" :formatter="formatter" label="发车单筐均重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>
      <van-collapse-item title="发车信息" name="2">
        <b-table class="bgc-dark" head-variant="dark" responsive bordered
                 :items="inputForm.detailList1" :fields="fields1">
          <template v-slot:head()="scope">
            <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(totalWeightIncludePack)="data">
            {{ Number(data.item.totalWeightIncludePack).toFixed(2) }}
          </template>
          <template v-slot:cell(totalWeightExcludePack)="data">
            {{ data.item.totalWeightExcludePack !== undefined && data.item.totalWeightExcludePack !== null && data.item.totalWeightExcludePack !== '' ? Number(data.item.totalWeightExcludePack).toFixed(4) : '-' }}
          </template>
          <template v-slot:cell(avgWeightIncludePack)="data">
            {{ data.item.avgWeightIncludePack !== undefined && data.item.avgWeightIncludePack !== null && data.item.avgWeightIncludePack !== '' ? Number(data.item.avgWeightIncludePack).toFixed(2) : '-' }}
          </template>
          <template v-slot:cell(avgWeightExcludePack)="data">
            {{ data.item.avgWeightExcludePack !== undefined && data.item.avgWeightExcludePack !== null && data.item.avgWeightExcludePack !== '' ? Number(data.item.avgWeightExcludePack).toFixed(4) : '-' }}
          </template>


          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
        </b-table>
      </van-collapse-item>
      <van-collapse-item title="口岸换装信息" name="3">
        <van-field v-model="inputForm.actualPortArrivalTime" label="实际到达口岸时间" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.transferEndTime" label="换装结束时间" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.escortVehiclePeriod" label="押车时段（h)" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.actualReceiverName" label="实际接货人姓名" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.actualReceiverPhone" label="实际接货人联系电话" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.portTotalWeightIncludePack" label="口岸换装含筐总重（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.portTotalNum" label="口岸换装总件数（筐）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.portAvgWeightPerBasket" label="口岸换装单筐均重（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.portTotalWeightExcludePack" label="口岸换装不含筐总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.portAvgWeightExcludePerBasket" label="口岸换装单筐不含筐均重（斤/件）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <b-table class="bgc-dark" head-variant="dark" responsive bordered
                 :items="inputForm.detailList2" :fields="fields2">
          <template v-slot:head()="scope">
            <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(totalWeightIncludePack)="data">
            {{ Number(data.item.totalWeightIncludePack).toFixed(2) }}
          </template>
          <template v-slot:cell(totalWeightExcludePack)="data">
            {{ data.item.totalWeightExcludePack !== undefined && data.item.totalWeightExcludePack !== null && data.item.totalWeightExcludePack !== '' ? Number(data.item.totalWeightExcludePack).toFixed(4) : '-' }}
          </template>
          <template v-slot:cell(avgWeightIncludePack)="data">
            {{ data.item.avgWeightIncludePack !== undefined && data.item.avgWeightIncludePack !== null && data.item.avgWeightIncludePack !== '' ? Number(data.item.avgWeightIncludePack).toFixed(2) : '-' }}
          </template>
          <template v-slot:cell(avgWeightExcludePack)="data">
            {{ data.item.avgWeightExcludePack !== undefined && data.item.avgWeightExcludePack !== null && data.item.avgWeightExcludePack !== '' ? Number(data.item.avgWeightExcludePack).toFixed(4) : '-' }}
          </template>


          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
        </b-table>
      </van-collapse-item>
      <van-collapse-item title="换装前车辆信息" name="4">
        <van-field v-model="inputForm.plateNo" label="境内运输车牌号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckDriverName" label="货车司机" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckDriverPhone" label="货车司机联系方式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>
      <van-collapse-item title="换装后车辆信息" name="5">
        <van-field v-model="inputForm.internationPlateNo" label="国际运输车牌号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.transferFee" :formatter="formatter" label="换装费（元）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.carFrontAttachList.length > 0">
          <p style="color: #AAA">车头照片</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.carFrontAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.carBodyAttachList.length > 0">
          <p style="color: #AAA">车身照片</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.carBodyAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.carTailAttachList.length > 0">
          <p style="color: #AAA">车尾照片</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.carTailAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList.length > 0">
          <p style="color: #AAA">随车附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <van-field v-model="inputForm.remark" label="备注" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>


<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";
import {Decimal} from "decimal.js";

export default {
  name: "ItsLogisticTransfer",
  data() {
    return {
      activeNames: ['1', '2', '3', '4', '5'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      inputForm: {
        carFrontAttachList: [],
        carBodyAttachList: [],
        carTailAttachList: [],
        attachList: [],
        isDoTask: false,
        isLastTask: false,
        transferType: undefined,
        salesDepartNo: undefined,
      },
      flowTable: 'its_logistic_transfer',
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'fruitTypeLabel', label: '果品类型', width: '120px'},
        {key: 'brandName', label: '产品品牌', width: '120px'},
        {key: 'varietyLevelLabel', label: '产品等级', width: '120px'},
        {key: 'totalWeightIncludePack', label: '发车含筐总重（斤）', width: '120px'},
        {key: 'num', label: '发车件数（筐）', width: '120px'},
        {key: 'totalWeightExcludePack', label: '发车不含筐总重（斤）', width: '130px'},
        {key: 'avgWeightIncludePack', label: '发车单筐含筐均重（斤/件）', width: '130px'},
        {key: 'avgWeightExcludePack', label: '发车单筐不含筐均重（斤/件）', width: '140px'},
      ],
      fields2: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'fruitTypeLabel', label: '果品类型', width: '120px'},
        {key: 'brandName', label: '产品品牌', width: '120px'},
        {key: 'varietyLevelLabel', label: '产品等级', width: '120px'},
        {key: 'totalWeightIncludePack', label: '口岸换装含筐总重（斤）', width: '130px'},
        {key: 'num', label: '口岸换装件数（筐）', width: '120px'},
        {key: 'totalWeightExcludePack', label: '口岸换装不含筐总重（斤）', width: '140px'},
        {key: 'avgWeightIncludePack', label: '发车单筐含筐均重（斤/件）', width: '130px'},
        {key: 'avgWeightExcludePack', label: '发车单筐不含筐均重（斤/件）', width: '140px'},
      ],
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/logistic/itsLogisticTransfer/queryById').then(({data}) => {
        this.inputForm = data
        this.inputForm.createDate = data.createDate.slice(0,10)
        this.getDict([
          ['its_customs_type', 'transferType'],
        ]);
        this.updateDictNames(this.inputForm.detailList1,{
          its_fruit_type:'fruitType',
          its_base_variety_level:'varietyLevel'
        })
        this.updateDictNames(this.inputForm.detailList2,{
          its_fruit_type:'fruitType',
          its_base_variety_level:'varietyLevel'
        })
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts){
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item=>item.value==this.inputForm[formField]).label);
        });
      }).catch(e => {
        console.log(e)
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Label`, dictItem.label);
            }
          }
        }
      });
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value) {
      return Number(value).toFixed(2)
    },
    viewDetail() {
      this.$router.push({
        path: '/ItsLaborDailyDetail',
        query: {
          data: JSON.stringify(this.inputForm.dailyDetailList1)
        }
      })
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
  }
}
</script>

<style scoped>

</style>
